export class GetRewardfulInfo {
  static type = '[Rewardful] Get Rewardful Info';

  constructor() {}
}
